<template>
  <TemplateContentSubNav>
    <template #navigation>
      <DisplaySection gap="xl" tag="nav">
        <NavigationButtonBackFromLinks :links="links" />
      </DisplaySection>
    </template>

    <TemplateSectionWithHeader v-if="library && library.content">
      <template #header>
        <header v-cleaned="library.content" />
      </template>
      <LbViewRouter />
    </TemplateSectionWithHeader>

    <LbViewRouter v-else />
  </TemplateContentSubNav>
</template>
<script lang="ts" setup>
const profile = useProfileStore();

const route = useRoute();

const { greaterOrEqual } = useEvaBreakpoints();

const isAboveL = greaterOrEqual('l');

const { libraryManager, libraryViewRouter } = inject(
  INJECT_LIBRARY_PAGE_OR_FORM
);
const { t } = useI18n();

const { library, libraryBook, links } = libraryManager;

if (library.value) useAppEventLibraryBox(library.value);

const isIndex = computed(() => route.path === '/nomad');

if (isIndex.value) {
  useAppEventView(EventView.NomadPlus, library.value.id);
}

useWebsiteHead({
  title: isIndex.value
    ? `Nomad+ - ${t('title.nomadplus')}`
    : `Nomad+ - ${library?.value?.title || libraryBook?.value?.metaTitle}`,
});
</script>
<style lang="scss" scoped>
.banner {
  display: flex;
}

.subsection {
  .banner {
    @include above('l') {
      display: none;
    }
  }
}
</style>
